<template>
	<div class="adminMangeListing">
		<b-row class="sub-header input-div" align-h="around">
			<b-col class="text-center mt-3">
				<b-form-input
					:placeholder="$t('userDashboard.messages.search')"
					class="input-search"
					v-model="searchParams.search"
				></b-form-input>
			</b-col>
			<b-col class="text-center mt-3" cols="12" md>
				<b-dropdown class="menu-dropdown" no-flip>
					<template v-slot:button-content>
						<span>
							{{
								catagoryItem != null
									? $t(catagoryItem.name)
									: $t('all')
							}}
							<ChevronDownIcon />
						</span>
					</template>
					<b-dropdown-item
						v-for="(value, index) in categoriesOptions"
						@click="handleCatagory(value)"
						v-bind:key="`sub-category-${index}`"
						>{{ $t(value.name) }}</b-dropdown-item
					>
				</b-dropdown>
			</b-col>
			<b-col class="text-center mt-3" cols="12" md>
				<b-dropdown class="menu-dropdown" no-flip>
					<template v-slot:button-content>
						<span>
							{{
								statusItem != null
									? $t(statusItem.text)
									: status
									? $t(status[0].text)
									: ''
							}}
							<ChevronDownIcon />
						</span>
					</template>
					<b-dropdown-item
						v-for="(value, index) in status"
						v-bind:key="`sub-category-${index}`"
						@click="handleStatus(value)"
						>{{ $t(value.text) }}</b-dropdown-item
					>
				</b-dropdown>
			</b-col>
			<b-col class="text-center mt-3" cols="6" md>
				<b-button
					id="changeViewTypeGrid"
					@click="changeTypeViewAlllistings('grid')"
					class="btn-grid"
					v-bind:class="{ active: typeViewAlllistings == 'grid' }"
				>
					<ListGridIcon />
				</b-button>
				<b-button
					id="changeViewTypeList"
					@click="changeTypeViewAlllistings('list')"
					class="btn-list"
					v-bind:class="{ active: typeViewAlllistings == 'list' }"
				>
					<FormatListBulletedIcon />
				</b-button>
			</b-col>
			<b-col class="text-center mt-3" cols="6" md>
				<b-button
					id="fetchDataSearch"
					@click="fetchDataSearch"
					type="submit"
					class="btn-submit-search"
					>{{ $t('listingDetail.messages.modal.search') }}</b-button
				>
			</b-col>
		</b-row>
		<div
			class="wrap-list list-all-listings"
			v-if="typeViewAlllistings == 'list'"
		>
			<b-table
				responsive
				hover
				:fields="fields"
				:items="searchData"
				thead-class="hidden_header"
				:tbody-tr-class="tbodyTrClass"
			>
				<template v-slot:cell(avatar)="data">
					<b-avatar
						:size="isMobile ? 30 : 66"
						class="bg-transparent"
						:src="
							data.item.user && data.item.user.profile_image
								? data.item.user.profile_image
								: '/images/avatar.png'
						"
					></b-avatar>
				</template>
				<template v-slot:cell(title)="data">
					<div>
						<b-card-text class="categories-name">
							{{ data.item.title }}
						</b-card-text>
						<div class="category">
							{{
								data.item.listing_category.listing_category_parent &&
									data.item.listing_category.listing_category_parent.name
							}}
							> {{ data.item.listing_category.name }}
						</div>
						<div class="posted-date-div">
							<EditIcon />
							<div class="posted-date">
								{{ formatDate(data.item.created_at) }} -
								{{ formatHour(data.item.created_at) }}
							</div>
						</div>
						<div class="tab-price">
							Price
							{{ data.item.price ? data.item.price.toLocaleString('th-TH') : $t('caption.uponRequest') }}
							{{ data.item.price ? $t('baht'):'' }}
						</div>
					</div>
				</template>
				<template v-slot:cell(status)="data">
					<div class="column2">
						<div class="paid-promote-option">
							<div
								v-if="
									checkExistPackage('ThairathPackage', data.item.user_payments)
								"
								style="width:100px;height:100px;z-index:9;
											position: absolute;
											top: 20px;right: 0;padding-left: 50px;cursor:pointer"
							>
								<div
									style="
											color: white;
											width: 33px;
											height: 32px;
											display: -webkit-box;
											display: -ms-flexbox;
											display: flex;
											-webkit-box-pack: center;
											-ms-flex-pack: center;
											justify-content: center;
											background: var(--projectPrimaryColor) !important;border-radius: 50%;
											align-items: center;"
								>
									<IconHome style="height: 1em; width: 1em;color:white;" />
								</div>
							</div>
							<div
								v-if="checkExistPackage('Feature', data.item.user_payments)"
								class="bookmark"
							>
								<div class="start-while">
									<StarIcon />
								</div>
							</div>
							<div
								v-if="checkExistPackage('QuickSale', data.item.user_payments)"
								class="hot"
							>
								<div>{{ $t('approveListing.quickSale') }}</div>
							</div>
							<b-button
								v-if="checkExistPackage('Negotiable', data.item.user_payments)"
								class="btn-negotiable"
								>{{ $t('packages.negotiable.title') }}</b-button
							>
							<div
								v-if="checkExistPackage('Bumpup', data.item.user_payments)"
								class="bump-up"
							>
								<ChevronDoubleUpIcon />
							</div>
							<div
								v-if="checkExistPackage('Website', data.item.user_payments)"
								class="bump-up"
							>
								<MonitorIcon />
							</div>
						</div>
						<div class="user">
							<router-link
								id="sellerDetail"
								class="sellar-div"
								:to="$i18nRoute({ name: 'seller-detail' }, data.item.user.id)"
							>
								<AccountOutlineIcon />
								<span
									:id="'userStatus_' + data.item.id"
									:class="{
										suppend: userStatus(data.item.user),
										delete: userStatus(data.item.user)
									}"
									>{{ data.item.user.display_name.match(/([^\s]+)/g)[0] }}</span
								>
							</router-link>
							<!-- <span :id="'userStatus_'+item.id" :class="{'suppend': userStatus(item.user), 'delete': userStatus(item.user)}">{{item.user && funcSubString(item.user.display_name,30)}}</span> -->
							<b-tooltip
								v-if="
									Boolean(data.item.user.is_suspend) ||
										Boolean(data.item.user.is_deleted)
								"
								:target="'userStatus_' + data.item.id"
								placement="top"
								custom-class="tool-tips"
							>
								<span v-if="Boolean(!data.item.user.is_deleted)"
									>{{$t('User has been deleted')}}</span
								>
								<span v-if="Boolean(!data.item.user.is_suspend)"
									>{{$t('The user has been suspended')}}</span
								>
							</b-tooltip>
						</div>
					</div>
				</template>

				<template v-slot:cell(view)="data">
					<div class="column3">
						<div class="total-amount" v-if="data.item.total_paid_amount">
							{{$t('collective promotion')}}: {{ data.item.total_paid_amount }} {{ $t('baht') }}
						</div>
						<div class="location">
							<MapMarkerIcon />
							<span>{{ data.item.ip_location }}</span>
						</div>
					</div>
				</template>
				<template
					v-if="$route.name === 'AdminManageListing'"
					v-slot:cell(index)="data"
				>
					<div
						class="action-div"
						v-bind:class="{ active: idxActive == data.index + 1 }"
						@click="activeAction(data.index + 1, data.item)"
						:target="'action' + data.index + 1"
						placement="right"
						trigger="hover"
						:style="
							Boolean(!data.item.is_deleted) &&
							Boolean(!data.item.is_incomplete)
								? { cursor: 'pointer' }
								: null
						"
					>
						<IconCogOutline :id="'action' + data.index + 1" />
					</div>
					<b-popover
						:target="'action' + data.index + 1"
						placement="right"
						trigger="click"
						:disabled="
							Boolean(data.item.is_incomplete) || Boolean(data.item.is_deleted)
						"
					>
						<div class="icon-button">
							<div
								v-if="
									Boolean(!data.item.user.is_deleted) &&
										Boolean(!data.item.user.is_suspend)
								"
								class="button-div one"
								@click="gotoListingDetails(data.item)"
							>
								<EyeIcon />
								<span class="text">{{$t('see')}}</span>
								<!-- see -->
							</div>
							<div
								v-if="Boolean(data.item.is_show_renew)"
								class="button-div one"
								@click="onRenew(data.item.id)"
							>
								<CheckIcon />
								<span class="text">{{$t('renew')}}</span>
								<!-- renew -->
							</div>
							<div
								v-if="
									Boolean(data.item.is_rejected) ||
										Boolean(data.item.is_suspend)
								"
								class="button-div one"
								@click="approveListing(data.item.id)"
							>
								<CheckIcon />
								<span class="text">{{$t('approve')}}</span>
								<!-- approve -->
							</div>
							<div
								v-if="
									data.item.is_suspend == 0 &&
										data.item.is_rejected == 0 &&
										Boolean(!data.item.user.is_deleted) &&
										Boolean(!data.item.user.is_suspend)
								"
								class="button-div two"
								@click="suspendItem(data.item.title, data.item.id)"
							>
								<EyeOffOutlineIcon />
								<span class="text">{{$t('suspend')}}</span>
								<!-- Suspend -->
							</div>
							<div
								class="button-div three"
								@click="deletedItem(data.item.title, data.item.id)"
							>
								<TrashIcon />
								<span class="text">{{$t('delete')}}</span>
								<!-- delete -->
							</div>
						</div>
					</b-popover>
				</template>
			</b-table>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results"
					><b-alert show variant="light" v-if="!searchData.length">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert></span
				>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
		<div
			class="wrap-list grid-listings pr-0 pr-md-3"
			v-if="typeViewAlllistings == 'grid'"
		>
			<div class="grid-div" v-for="item in searchData" :key="item.id">
				<b-row class="grid">
					<div
						v-for="paymentDetails in item.user_payments"
						:key="paymentDetails.id"
					>
						<div
							v-for="packageDetails in paymentDetails.user_payments_details"
							:key="packageDetails.id"
						>
							<span
								class="featured"
								v-if="packageDetails.packages_detail&&packageDetails.packages_detail.package_id == 1"
							></span>
							<span
								class="highlighted"
								v-if="
									packageDetails.packages_detail&&packageDetails.packages_detail.package_id != 1 &&
										packageDetails.packages_detail.package_id == 5
								"
							></span>
						</div>
					</div>
					<b-col class="left-side">
						<div
							class="status"
							v-if="checkExistPackage('QuickSale', item.user_payments)"
						>
							<span>{{$t('express')}}</span>
						</div>
						<div
							class="card-img"
							@click="gotoListingDetails(item)"
							:style="
								Boolean(!item.is_deleted) && Boolean(!item.is_incomplete)
									? { cursor: 'pointer' }
									: null
							"
						>
							<div class="status-listing">
								<span v-if="item.is_deleted != 0">{{$t('deleted')}}</span>
								<span v-if="item.is_rejected != 0 && item.is_deleted == 0"
									>{{$t('disapproved')}}</span
								>
								<span
									v-if="item.user.is_suspend != 0 && item.user.is_deleted == 0"
									>{{$t('suspended')}}</span
								>
								<span v-if="item.is_suspend != 0 && item.is_deleted == 0"
									>{{$t('suspended')}}</span
								>
								<span v-if="item.is_incomplete == 1 && item.is_deleted == 0"
									>{{$t('incomplete information')}}</span
								>
								<span v-if="item.status == 5 || item.status == 4">{{
									item.status == 5
										? $t('userDashboard.userManage.setting.sold')
										: $t('rented')
								}}</span>
							</div>
							<img :src="item.url_feature_image.replace('832x468', '250x141')" class="main-image" v-if="item.url_feature_image" :alt="item.title"/>
							<div
								class="status-listing"
								style="top: 83%;transform: none;width: 100%;left: 0;color: var(--projectPrimaryColor) !important;"
							>
								<!--job category-->
								<span
									v-if="!item.salaryType"
									style="color: var(--projectPrimaryColor) !important;border-radius: 0;font-size: 18px;font-weight: bold;"
								>
									{{
										item.minSalary
											? `${item.minSalary.toLocaleString('th-TH')} ${$t(
													'baht'
											  )} - `
											: ''
									}}
									{{ item.price ? item.price.toLocaleString('th-TH') : $t('caption.uponRequest') }}
									{{ item.price ? $t('baht'):'' }}
								</span>
								<span class="card-cost" v-if="item.salaryType">
									{{ item.salaryType }}
								</span>
							</div>
						</div>

						<div class="thumbnail d-none d-md-block">
							<span v-for="(image, index) in item.listing_images" :key="index">
								<img :src="image.url_image.replace('832x468', '250x141')" v-if="index !== 0&&image.url_image" :alt="item.title"/>
							</span>
						</div>
					</b-col>
					<b-col class="right-side">
						<b-card-text class="categories-name pl-2 pl-md-0">
							{{ item.title }}
						</b-card-text>
						<span class="category pl-2 pl-md-0"
							>{{ item.listing_category.listing_category_parent&&item.listing_category.listing_category_parent.name?$t(item.listing_category.listing_category_parent.name):'' }} >
							{{ $t(item.listing_category.name) }}</span
						>
						<div class="date-and-location pl-2 pl-md-0">
							<div class="createdAt">
								<EditIcon />
								<div class="posted-date">
									{{$t('post')}} {{ formatDate(item.created_at) }} -
									{{ formatHour(item.created_at) }}
								</div>
							</div>
							<div class="location">
								<MapMarkerIcon />
								<span>{{ item.ip_location }}</span>
							</div>
						</div>
						<div class="paid-promote-option">
							<div class="package">
								<div
									v-if="
										checkExistPackage('ThairathPackage', item.user_payments)
									"
									style="width:100px;height:100px;z-index:9;
											position: absolute;
											top: 20px;right: 0;padding-left: 50px;cursor:pointer"
								>
									<div
										style="
											color: white;
											width: 33px;
											height: 32px;
											display: -webkit-box;
											display: -ms-flexbox;
											display: flex;
											-webkit-box-pack: center;
											-ms-flex-pack: center;
											justify-content: center;
											background: var(--projectPrimaryColor) !important;border-radius: 50%;
											align-items: center;"
									>
										<IconHome style="height: 1em; width: 1em;color:white;" />
									</div>
								</div>
								<div
									v-if="checkExistPackage('Feature', item.user_payments)"
									class="bookmark"
								>
									<div class="start-while">
										<StarIcon />
									</div>
								</div>
								<div
									v-if="checkExistPackage('QuickSale', item.user_payments)"
									class="hot"
								>
									<div>{{ $t('approveListing.quickSale') }}</div>
								</div>
								<b-button
									v-if="checkExistPackage('Negotiable', item.user_payments)"
									class="btn-negotiable"
									>{{ $t('packages.negotiable.title') }}</b-button
								>
								<div
									v-if="checkExistPackage('Bumpup', item.user_payments)"
									class="bump-up"
								>
									<ChevronDoubleUpIcon />
								</div>
								<div
									v-if="checkExistPackage('Website', item.user_payments)"
									class="bump-up"
								>
									<MonitorIcon />
								</div>
							</div>
							<div class="total-amount" v-if="item.total_paid_amount">
								{{$t('collective promotion')}}: {{ item.total_paid_amount }} {{ $t('baht') }}
								{{ $t('baht') }}
							</div>
						</div>
						<div class="user pl-2 pl-md-0">
							<div>
								<router-link
									id="sellerDetail"
									class="sellar-div"
									:to="$i18nRoute({ name: 'seller-detail' }, item.user.id)"
								>
									<AccountOutlineIcon />
									<span
										:id="'userStatus_' + item.id"
										:class="{
											suppend: userStatus(item.user),
											delete: userStatus(item.user)
										}"
										>{{ item.user.display_name.match(/([^\s]+)/g)[0] }}</span
									>
								</router-link>
								<!-- <span :id="'userStatus_'+item.id" :class="{'suppend': userStatus(item.user), 'delete': userStatus(item.user)}">{{item.user && funcSubString(item.user.display_name,30)}}</span> -->
								<b-tooltip
									v-if="
										Boolean(item.user.is_suspend) ||
											Boolean(item.user.is_deleted)
									"
									:target="'userStatus_' + item.id"
									placement="top"
									custom-class="tool-tips"
								>
									<span v-if="Boolean(!item.user.is_deleted)"
										>{{$t('User has been deleted')}}</span
									>
									<span v-if="Boolean(!item.user.is_suspend)"
										>{{$t('The user has been suspended')}}</span
									>
								</b-tooltip>
							</div>
							<div>
								{{$t('approve')}}
								<span class="approved"
									>({{ item.user && item.user.total_listing_approved }})</span
								>
							</div>
							<div>
								{{$t('disapproved')}}
								<span class="rejected"
									>({{ item.user && item.user.total_listing_rejected }})</span
								>
							</div>
							<div>
								{{ $t('all') }}
								<span class="total"
									>({{ item.user && item.user.total_listing }})</span
								>
							</div>
						</div>
						<div
							class="button-div justify-content-center"
							v-if="
								(Boolean(!item.is_incomplete) || Boolean(item.is_deleted)) &&
									$route.name === 'AdminManageListing'
							"
						>
							<b-button
								v-if="Boolean(!item.is_deleted)"
								id="gotoListingDetails"
								class="btn-grid"
								@click="gotoListingDetails(item)"
							>
								<EyeIcon />
								<span class="d-none d-md-inline">{{$t('see')}}</span>
							</b-button>
							<!-- see -->
							<b-button
								v-if="
									Boolean(!item.is_suspend) &&
										Boolean(!item.is_rejected) &&
										Boolean(!item.is_deleted)
								"
								class="btn-grid ml-4"
								@click="onRenew(item.id)"
								id="onRenew"
							>
								<CheckIcon />
								<span class="d-none d-md-inline">{{$t('renew')}}</span>
								<!-- renew -->
							</b-button>
							<b-button
								v-if="
									Boolean(!item.is_suspend) &&
										Boolean(!item.is_rejected) &&
										Boolean(!item.is_deleted)
								"
								class="rejected ml-4"
								@click="suspendItem(item.title, item.id)"
								id="onReject"
							>
								<EyeOffOutlineIcon />
								<span class="d-none d-md-inline">{{$t('suspend')}}</span>
								<!-- Suspend -->
							</b-button>

							<b-button
								v-if="Boolean(!item.is_deleted)"
								class="delete ml-4"
								@click="deletedItem(item.title, item.id)"
								id="onDeleted"
							>
								<TrashIcon />
								<span class="d-none d-md-inline">{{$t('delete')}}</span>
								<!-- delete -->
							</b-button>
						</div>
					</b-col>
				</b-row>
				<b-row
					class="approved-div m-2 mt-3 mb-3 m-md-3"
					align-v="center"
					align-h="between"
				>
					<div class="sub-div">
						{{$t('approved by')}}<br />
						<span>{{ item.approved_by ? item.approved_by : '-' }}</span>
						<span v-if="item.approved_by"
							>{{ formatDate(item.approval_date) }} -
							{{ formatHour(item.approval_date) }}</span
						>
					</div>
					<div class="sub-div">
						{{$t('Disapproved by')}}<br />
						<span>{{ item.rejected_by ? item.rejected_by : '-' }}</span>
						<span v-if="item.rejected_by"
							>{{ formatDate(item.rejected_date) }} -
							{{ formatHour(item.rejected_date) }}</span
						>
					</div>
					<div class="sub-div">
						{{$t('suspended by')}}<br />
						<span>{{ item.suspended_by ? item.suspended_by : '-' }}</span>
						<span v-if="item.suspended_by"
							>{{ formatDate(item.suspended_date) }} -
							{{ formatHour(item.suspended_date) }}</span
						>
					</div>
					<div class="sub-div">
						{{$t('delete by')}}<br />
						<span>{{ item.deleted_by ? item.deleted_by : '-' }}</span>
						<span v-if="item.deleted_by"
							>{{ formatDate(item.deleted_at) }} -
							{{ formatHour(item.deleted_at) }}</span
						>
					</div>
				</b-row>
			</div>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results"
					><b-alert show variant="light" v-if="!searchData.length">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert></span
				>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

// Icons
import StarIcon from 'vue-material-design-icons/Star.vue';
import MonitorIcon from 'vue-material-design-icons/Monitor.vue';
import ChevronDoubleUpIcon from 'vue-material-design-icons/ChevronDoubleUp.vue';
import EditIcon from '@/components/icons/IconEdit/index';
import AccountOutlineIcon from 'vue-material-design-icons/AccountOutline.vue';
import MapMarkerIcon from 'vue-material-design-icons/MapMarker.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import EyeOffOutlineIcon from 'vue-material-design-icons/EyeOffOutline.vue';
import IconCogOutline from '@/components/icons/IconCogOutline/index';
import EyeIcon from '@/components/icons/IconEye/index';
import TrashIcon from '@/components/icons/IconTrash';
import ListGridIcon from '@/components/icons/IconListGrid/index';
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import moment from 'moment';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import InfiniteLoading from 'vue-infinite-loading';
import IconHome from '@/components/icons/IconHome/index';
export default {
	components: {
		StarIcon,
		ChevronDoubleUpIcon,
		MonitorIcon,
		AccountOutlineIcon,
		MapMarkerIcon,
		IconCogOutline,
		EyeOffOutlineIcon,
		EyeIcon,
		CheckIcon,
		TrashIcon,
		ListGridIcon,
		FormatListBulletedIcon,
		ChevronDownIcon,
		InfiniteLoading,
		EditIcon,
		IconHome
	},
	data() {
		return {
			typeViewAlllistings: 'grid',
			options: [
				{ value: '0', text: this.$t('all') },
				{ value: '1', text: this.$t('market') },
				{ value: '2', text: this.$t('real estate') },
				{ value: '3', text: this.$t('car and engine') },
				{ value: '4', text: this.$t('work') }
			],
			status:
				this.$route.name === 'AdminManageListing'
					? [
							{ text: this.$t('all'), value: 'All' },
							{ text: this.$t('approved'), value: 'Approved' },
							{ text: this.$t('expire'), value: 'Expired' },
							{ text: this.$t('disapproved'), value: 'Rejected' },
							{ text: this.$t('suspend'), value: 'Suspend' }
					  ]
					: [
							{ text: this.$t('all'), value: 'SoldRented' },
							{ text: this.$t('rented'), value: 'Rented' },
							{ text: this.$t('Sold'), value: 'Sold' }
					  ],

			fields: [
				{ key: 'avatar', tdClass: 'tb-listing align-middle' },
				{ key: 'title', label: this.$t('announce'), tdClass: 'align-middle' },
				{ key: 'status', label: this.$t('status'), tdClass: 'align-middle' },
				{ key: 'view', label: this.$t('audience'), tdClass: 'align-middle' },
				{ key: 'index', tdClass: 'align-middle' }
			],
			currentRejectID: undefined,
			currentSuspendID: undefined,
			rejectMessage: null,
			selectedSortBy: null,
			sortBy: [{ value: null, text: this.$t('sort by') }],
			idxActive: '',
			catagoryItem: null,
			statusItem: null,
			searchParams: {
				take: 10,
				page: 1,
				search: null,
				listing_category_ids: null,
				status: this.$route.name === 'AdminManageListing' ? 'All' : 'SoldRented'
			}
		};
	},
	mounted() {
		this.GET_CATEGORY();

		this.$nextTick(() => {
			this.searchData;
		});
	},
	created() {
		this.fetchDataSearch(this.searchParams);
		document.getElementsByTagName('body')[0].addEventListener('click', e => {
			if (document.getElementsByClassName('popover').length) {
				this.$root.$emit('bv::hide::popover');
				this.idxActive = '';
			}
		});
	},
	computed: {
		...mapState('ListingDetailController', ['showRejectAcceptButton']),
		...mapGetters('UserController', ['isMobile']),
		...mapGetters('CategoryController', ['categoriesOptions']),
		...mapGetters('AdminManagerController', ['searchData'])
	},
	methods: {
		// getTotalAmount(user_payments) {
		//   return user_payments.reduce(function(result, item) {
		//     return result + item.total_amount;
		//   }, 0).toLocaleString("th-TH");
		// },
		onSuspend() {
			if (this.currentSuspendID && this.rejectMessage != '') {
				this.ADMIN_SUSPEND_LISTING({
					id: this.currentSuspendID
				}).then(result => {
					if (result.data.success) {
						this.$nextTick(() => {
							this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
						});
						this.rejectMessage = null;
						this.fetchDataSearch();
					}
				});
			}
		},
		checkPackage(val) {
			val.forEach(data => {
				if (data.package_id&&data.package_id == 3) {
					return true;
				}
			});
		},
		onChangeRejectMessage(val) {
			this.rejectMessage = val;
		},
		formatDate(date) {
			return moment(date)
				.locale('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		},
		checkExistPackage(type, user_payments) {
			switch (type) {
				case 'Feature':
					let existFeature = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 1) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existFeature;
					break;
				case 'Bumpup':
					let existBumpup = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&(
								temp.packages_detail.package_id === 1 ||
								temp.packages_detail.package_id === 2)
							) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existBumpup;
					break;
				case 'QuickSale':
					let existQuickSale = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 3) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existQuickSale;
					break;
				case 'Negotiable':
					let existNegotiable = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 4) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existNegotiable;
					break;
				case 'Highlight':
					let existHighlight = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&(
								temp.packages_detail.package_id === 1 ||
								temp.packages_detail.package_id === 5)
							) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existHighlight;
					break;
				case 'Website':
					let existWebsite = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 6) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existWebsite;
					break;
				case 'ThairathPackage':
					let ThairathPackage = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 7) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!ThairathPackage;
					break;
			}
			return false;
		},
		...mapActions('ListingDetailController', ['SHOW_REJECT_ACCEPT_BUTTON']),
		...mapActions('AdminManagerController', ['GET_DATA_SEARCH_ADMIN']),
		...mapActions('ListingAdminController', [
			'GET_LISTINGS_WAITING_FOR_APPROVE',
			'ADMIN_RENEW_LISTING',
			'ADMIN_REJECT_LISTING',
			'ADMIN_DELETE_LISTING',
			'ADMIN_APPROVE_LISTING',
			'ADMIN_SUSPEND_LISTING'
		]),
		...mapMutations('ListingDetailController', [
			'SET_SHOW_REJECT_ACCEPT_BUTTON'
		]),
		...mapActions('CategoryController', ['GET_CATEGORY']),
		changeTypeViewAlllistings(type) {
			this.typeViewAlllistings = type;
		},
		goToPromoteOption() {
			this.$router.push(this.$i18nRoute({ name: 'packages-screen' }));
		},
		tbodyTrClass(item) {
			if (this.checkExistPackage('Highlight', item.user_payments)) {
				return 'hidden_header_active';
			}
			return '';
		},
		onRenew(id) {
			this.ADMIN_RENEW_LISTING({
				id
			})
				.then(result => {
					this.$bvToast.toast('Renew Success', {
						title: `Success!`,
						variant: 'primary',
						solid: true
					});
					this.$nextTick(() => {
						this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
					});
					this.fetchDataSearch();
				})
				.catch(err => {
					this.$bvToast.toast('Already renwed', {
						title: `error!`,
						variant: 'danger',
						solid: true
					});
				});
		},
		deletedItem(name, id) {
			this.$swal({
				title: this.$t('You want to delete the announcement'),
				text: this.funcSubString(name, 30),
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				cancelButtonColor: '#DC3849',
				confirmButtonText: this.$t('cancel'),
				cancelButtonText: this.$t('delete')
			}).then(result => {
				if (result.dismiss == 'cancel') {
					this.ADMIN_DELETE_LISTING({
						id
					});
					this.$nextTick(() => {
						this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
					});
					setTimeout(() => {
						this.fetchDataSearch();
					}, 300);
				}
			});
		},
		showSuggestions(suggest) {
			this.$swal({
				title: this.$t('Advice from administrators'),
				text: suggest,
				customClass: {
					container: 'swal-suggest'
				},
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				confirmButtonText: this.$t('acknowledge')
			});
		},
		gotoListingDetails(item) {
			if (Boolean(item.is_deleted) || Boolean(item.is_incomplete)) {
				return;
			}

			if (Boolean(!item.is_rejected)) {
				this.$router.push(
					this.$i18nRoute(
						{
							name: 'listing-detail'
						},
						item.id
					)
				);
				return;
			} else {
				this.$router.push(
					this.$i18nRoute(
						{
							name: 'admin-approve-listing'
						},
						item.id
					)
				);
			}
		},
		activeAction(idx, item) {
			if (Boolean(item.is_incomplete) || Boolean(item.is_deleted)) {
				return;
			}
			this.idxActive = idx;
		},
		approveListing(listing_id) {
			this.ADMIN_APPROVE_LISTING({
				id: listing_id
			}).then(result => {
				this.$nextTick(() => {
					this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
				});
				if (result.success) {
					this.fetchDataSearch();
				}
			});
		},
		suspendItem(title, id) {
			this.currentSuspendID = id;
			this.$swal({
				title: this.$t('You want to suspend the announcement'),
				text: this.funcSubString(title, 30),
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				cancelButtonColor: '#EBAC00',
				confirmButtonText: this.$t('cancel'),
				cancelButtonText: this.$t('suspend')
			}).then(result => {
				if (result.dismiss == 'cancel') {
					this.onSuspend();
				}
			});
		},
		handleCatagory(item) {
			this.catagoryItem = item;
			this.searchParams.listing_category_ids = item.id.toString();
		},
		handleStatus(item) {
			this.statusItem = item;
			this.searchParams.status = item.value;
		},
		fetchDataSearch() {
			let prms = { ...this.searchParams };
			prms.page = 1;
			this.GET_DATA_SEARCH_ADMIN(prms);
		},
		funcSubString(string, number) {
			let subStr = '';
			if (string.length > number && string.indexOf(' ') !== -1) {
				subStr =
					string.substring(0, string.substring(0, number).lastIndexOf(' ')) +
					' ...';
			} else {
				subStr = string;
			}
			return subStr.toString();
		},
		infiniteHandler($state) {
			let prms = { ...this.searchParams };

			prms.page += 1;

			this.searchParams = prms;

			this.GET_DATA_SEARCH_ADMIN(prms).then(async response => {
				if (response.data.data.length > 0) {
					await $state.loaded();
				} else {
					await $state.complete();
				}
			});
		},
		checkUserStatus(item) {
			let status = true;
			if (Boolean(item.is_deleted)) {
				status = true;
			} else {
				if (Boolean(item.is_suspend)) {
					status = true;
				}
			}
		},
		userStatus(item) {
			if (item.is_suspend == 1 && item.is_deleted != 1) {
				return true;
			} else {
				if (item.is_deleted == 1) {
					return true;
				}
			}
			return false;
			//  :class="{'suppend': Boolean(item.user.is_suspend) && Boolean(!item.user.is_deleted), 'delete': Boolean(item.user.is_deleted)}"
		},
		getListingAttr() {
			this.searchData.forEach(element => {
				element.listing_attributes_details.forEach(subElement => {
					if (subElement.attr_id == 15) {
						element.minSalary = subElement.value ? subElement.value : 0;
					}
					if (subElement.attr_id == 18 && subElement.pre_values_id != 56) {
						element.salaryType = subElement.listing_pre_value.value
							? subElement.listing_pre_value.value
							: null;
					}
				});
			});
		}
	},
	watch: {
		searchData: function(val) {
			this.getListingAttr();
		}
	}
};
</script>

<style lang="scss">
@import 'adminManageListing.scss';
</style>
